const th = {
  // Navbar
  nav_home: "หน้าแรก",
  nav_about: "เกี่ยวกับลุงเทนเทน",
  nav_services: "บริการและราคา",
  nav_flow: "ขั้นตอนการให้บริการ",
  nav_testimonials: "รีวิวจากลูกค้า",
  nav_faq: "คำถามที่พบบ่อย",
  nav_contact: "ติดต่อเรา",
  nav_cta: "จองการอ่านชื่อ",
  nav_subtitle: "การอ่านชื่อ · โอกินาวา",
  nav_title: "สำนักงานลุงเทนเทน",

  // Hero
  hero_headline1: "ท่ามกลางความสงบ",
  hero_headline2: "บนเกาะโอกินาวา",
  hero_headline3: "เราฟังเสียง",
  hero_headline4: "ของชื่อคุณ",
  hero_body: "การจองอ่านชื่อมีรายชื่อรอคิวนานหลายเดือน\nทุกเดือนฉันเดินทางไปยังเกาะโอกินาวาด้วยตัวเอง\nเพื่อส่งชื่อของคุณถึงอาจารย์",
  hero_pill1: "ไม่ต้องเปลี่ยนชื่อ",
  hero_pill2: "100% ออนไลน์",
  hero_pill3: "ส่งผลภายใน 1 เดือน",
  hero_pill4: "100 ที่นั่งต่อเดือน",
  hero_btn_apply: "จองการอ่านชื่อ",
  hero_btn_services: "ดูบริการ",
  hero_scroll: "เลื่อนลง",

  // About
  about_heading: "เกี่ยวกับลุงเทนเทน",
  about_intro: "บน <strong>เกาะอิเคอิ</strong> ที่สงบงามท่ามกลางทะเลอบอุ่นของโอกินาวา\nมีชายคนหนึ่งที่เติมแสงสว่างเล็กๆ ให้กับทุกชื่อ\nผู้คนเรียกเขาด้วยความรักว่า <strong>\"ลุงเทนเทน\"</strong>",
  about_block1_label: "จากพนักงานธนาคารสู่นักอ่านชื่อ",
  about_block1_text: "ลุงเทนเทนเดิมเป็นพนักงานธนาคาร\nด้วยความขยันหมั่นเพียร เขาได้เป็น <strong>ผู้จัดการสาขาที่อายุน้อยที่สุด</strong> ของบริษัท\nจากการพบปะผู้คนมากมาย คำถามหนึ่งผุดขึ้นในใจเขา",
  about_block1_quote: "\"ทำไมบางคนถึงดูเหมือนมีลมพัดพาไปข้างหน้าแม้จะทำงานหนักเท่ากัน?\"",
  about_block1_sub: "คำถามเล็กๆ นั้นกลายเป็นจุดเริ่มต้นของการค้นพบครั้งยิ่งใหญ่",
  about_block2_label: "ภูมิปัญญาโบราณและแสงสว่างอันสงบ",
  about_block2_text: "เขาใช้เวลาว่างทั้งหมดศึกษาตำราโบราณเกี่ยวกับการอ่านชื่อ ค้นคว้าเส้นคันจิแบบดั้งเดิมและการไหลของเสียงอย่างละเอียด",
  about_block2_text2: "เขาตระหนักว่า <strong>\"จุดเทนเทนสามารถปรับสมดุลการไหลของชื่อได้อย่างอ่อนโยน\"</strong>",
  about_block2_sub: "นี่ไม่ใช่เวทมนตร์ที่ดราม่า ไม่ใช่สูตรสำเร็จสู่ความสำเร็จอันน่าอัศจรรย์\nแต่เป็นเส้นทางอ่อนโยนที่ทำให้แสงสว่างในตัวคุณปรากฏชัดขึ้น",
  about_block3_label: "บอกต่อปากต่อปาก — รอคิวนาน 6 เดือนแล้ว",
  about_block3_text: "การอ่านที่อบอุ่นของเขาแพร่กระจายด้วยการบอกต่อ และตอนนี้ <strong>มีคำถามหลั่งไหลมาจากทั่วประเทศอย่างไม่หยุดหย่อน</strong>\nเขาปฏิบัติต่อทุกคนด้วยหัวใจเดียวกัน ไม่ว่าจะมีชื่อเสียงหรือไม่\nวางมือบนทุกชื่อและเดินเคียงข้างชีวิตของทุกคน\nนั่นคือวิถีของลุงเทนเทน",

  // Gallery
  gallery_heading: "แกลเลอรีภาพถ่าย",
  gallery_sub: "โอกินาวา · เกาะอิเคอิ",

  // Services
  services_heading: "บริการและราคา",
  services_note1: "※ ทุกแพ็กเกจรวมค่าธรรมเนียมการอ่านของอาจารย์และค่าตัวแทน",
  services_note2: "※ ไม่มีค่าใช้จ่ายเพิ่มเติม คุณสามารถวางใจได้",
  services_tab1: "ชื่อบุคคล",
  services_tab2: "ชื่อธุรกิจ",
  services_tab3: "ชื่อสัตว์เลี้ยง",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "เราตรวจสอบการเติบโต สภาพแวดล้อม และการเคลื่อนไหวของหัวใจคุณอย่างอ่อนโยน แล้วเพิ่มจุดเทนเทนที่เหมาะสมที่สุด",
  services_tab2_desc: "นำลมอ่อนๆ มาสู่ความท้าทายใหม่ ปรับสมดุลการไหลของธุรกิจอย่างสงบ",
  services_tab3_desc: "สำหรับสมาชิกครอบครัวที่อยู่เคียงข้างคุณเสมอ มอบชื่อที่เต็มไปด้วยความสงบและอบอุ่น",
  services_row1_target1: "อายุ 16 ปีขึ้นไป",
  services_row1_target2: "อายุ 4-15 ปี",
  services_row1_target3: "อายุ 0-3 ปี",
  services_row2_target1: "ชื่อการค้า / บริษัท / ร้านค้า",
  services_row3_target1: "ชื่อสัตว์เลี้ยง",
  services_col_target: "กลุ่มเป้าหมาย",
  services_col_price: "ราคา (รวมภาษี)",
  services_cta: "จองบริการนี้",
  services_includes_title: "สิ่งที่รวมอยู่ในราคา (ทั้งหมด)",
  services_inc1: "การอ่านชื่อ",
  services_inc2: "คำแนะนำจุดเทนเทนที่ดีที่สุด",
  services_inc3: "ส่งการ์ดขนาดนามบัตร (ฟรีหากต้องการ)",
  services_inc4: "คำแนะนำโชคลาภ",
  services_inc5: "ภาพดิจิทัลของการ์ดชื่อ",
  services_includes_note: "จุดประสงค์ของการอ่านคือการเปิดเผยเวทมนตร์ที่มีอยู่แล้วในชื่ออย่างอ่อนโยน",
  services_payment_title: "วิธีการชำระเงิน",
  services_payment_method: "โอนเงินผ่านธนาคาร (ชำระล่วงหน้า)",
  services_payment_desc: "หลังจากลงทะเบียน เราจะให้รายละเอียดบัญชีธนาคาร\nเมื่อชำระเงินเสร็จสิ้น การไหลของโชคลาภจะเริ่มรวมตัวอย่างสงบ",
  services_first_title: "สำหรับผู้มาครั้งแรก",
  services_first_desc: "เป็นเรื่องธรรมดาที่จะรู้สึกไม่แน่ใจ\nความรู้สึกนั้นเป็นสัญญาณภายใน\nว่าถึงเวลาเริ่มต้นการเปลี่ยนแปลงอย่างอ่อนโยน",
  services_first_cta: "เริ่มต้นด้วยการปรึกษา",

  // Flow
  flow_heading: "ขั้นตอนการให้บริการ",
  flow_step1_title: "ส่งแบบฟอร์ม",
  flow_step1_c1: "กรอกข้อมูลที่จำเป็นในแบบฟอร์มเฉพาะ",
  flow_step1_c2: "เราจะตอบกลับภายใน 2-3 วันทำการหลังจากส่ง",
  flow_step1_c3: "อีเมลจะมีขั้นตอนถัดไปและคำแนะนำการโอนเงิน",
  flow_step2_title: "โอนค่าธรรมเนียมการอ่าน",
  flow_step2_c1: "โอนค่าธรรมเนียมการอ่านไปยังบัญชีที่ระบุในอีเมลตอบกลับ",
  flow_step2_c2: "หลังยืนยันการชำระเงิน เราจะเริ่มเตรียมการอ่านตามลำดับ",
  flow_step3_title: "แจ้งการโอนเงิน",
  flow_step3_c1: "หลังโอนเงิน ส่งภาพใบเสร็จไปยังที่อยู่ที่ระบุในอีเมล",
  flow_step3_c2: "หลังยืนยัน เราจะส่งข้อความ \"ลงทะเบียนเสร็จสมบูรณ์\"",
  flow_step3_note: "หากไม่มีการแจ้งนี้ เราไม่สามารถเริ่มการอ่านได้ กรุณาส่งให้แน่ใจ",
  flow_step4_title: "รับผลการอ่าน",
  flow_step4_c1: "หลังการอ่านเสร็จสิ้น เราจะส่งภาพการ์ดชื่อและจุดเทนเทนทางอีเมลภายในประมาณหนึ่งสัปดาห์",
  flow_step4_c2: "จากนั้นจะส่งรายงานการอ่านโดยละเอียดและคำแนะนำโชคลาภทางอีเมล",
  flow_step5_title: "ส่งการ์ดชื่อ (ตัวเลือก)",
  flow_step5_c1: "หากต้องการ เราจะส่งการ์ดขนาดนามบัตรที่เขียนด้วยมืออาจารย์ทางไปรษณีย์",
  flow_step5_c2: "กรุณากรอกที่อยู่ไปรษณีย์ที่ถูกต้องในช่องที่อยู่ของแบบฟอร์ม",
  flow_step5_note: "หากไม่ต้องการการ์ด ให้กรอกเพียงชื่อเมืองที่อยู่อาศัย",
  flow_banner_title: "ทุกอย่างออนไลน์ จากทุกที่ในญี่ปุ่น",
  flow_banner_desc: "ไม่จำเป็นต้องเดินทางไปยังเกาะอิเคอิในโอกินาวาด้วยตัวเอง\nคุณสามารถเริ่มต้นได้ทันทีโดยไม่ต้องเปลี่ยนกิจวัตรประจำวัน",
  flow_banner_cta: "ลงทะเบียนตอนนี้",

  // Testimonials
  testimonials_heading: "รีวิวจากลูกค้า",
  testimonials_viewing: "กำลังดู",

  // FAQ
  faq_heading: "คำถามที่พบบ่อย",
  faq_cta_title: "มีคำถามเพิ่มเติม?",
  faq_cta_desc: "คำถามเล็กๆ น้อยๆ ก็ยินดีต้อนรับ\nคำถามที่อาจรู้สึกอาย — นั่นแหละที่เราอยากฟังมากที่สุด",
  faq_cta_btn: "ถามคำถาม",

  // CTA Banner
  cta_heading1: "ฟรี",
  cta_heading2: "ปรึกษา",
  cta_btn: "จองตอนนี้",

  // Contact
  contact_heading: "ติดต่อเรา",
  contact_desc: "ส่งคำขออ่านหรือสอบถามผ่านแบบฟอร์มนี้ โดยปกติเราจะตอบกลับภายใน 2-3 วันทำการ",
  contact_address_label: "ที่อยู่",
  contact_address_value: "โทชิกิ ญี่ปุ่น (ออนไลน์ · บริการทั่วประเทศ)",
  contact_email_label: "อีเมล",
  contact_hours_label: "เวลาทำการ",
  contact_hours_value: "จันทร์–ศุกร์ 9:00–18:00 (ปิดเสาร์/อาทิตย์/วันหยุด)",
  contact_note_title: "เกี่ยวกับการตอบกลับ",
  contact_note_desc: "การตอบกลับอาจไปอยู่ในโฟลเดอร์สแปม\nหากไม่ได้รับการตอบกลับภายใน 2-3 วันทำการ กรุณาติดต่อทางอีเมลโดยตรง",
  contact_field_name: "ชื่อ",
  contact_field_furigana: "ฟุริกานะ (การออกเสียงชื่อ)",
  contact_field_email: "ที่อยู่อีเมล",
  contact_field_phone: "หมายเลขโทรศัพท์",
  contact_field_service: "บริการที่ต้องการ",
  contact_field_message: "ข้อความ",
  contact_placeholder_name: "สมชาย ใจดี",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+66 00 000 0000",
  contact_placeholder_message: "กรุณากรอกชื่อที่ต้องการอ่านหรือคำถามและคำขอของคุณ",
  contact_select_placeholder: "เลือก",
  contact_service1: "ชื่อบุคคล",
  contact_service2: "ชื่อธุรกิจ",
  contact_service3: "ชื่อสัตว์เลี้ยง",
  contact_service4: "อื่นๆ / สอบถาม",
  contact_submit: "ส่ง",
  contact_submitting: "กำลังส่ง...",
  contact_privacy: "ข้อมูลส่วนตัวที่ส่งผ่านแบบฟอร์มจะใช้เฉพาะสำหรับบริการอ่านชื่อเท่านั้น",
  contact_error: "การส่งล้มเหลว กรุณาลองอีกครั้งในภายหลังหรือติดต่อทางอีเมลโดยตรง",
  contact_err_name: "กรุณากรอกชื่อของคุณ",
  contact_err_email_required: "กรุณากรอกที่อยู่อีเมลของคุณ",
  contact_err_email_invalid: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
  contact_err_service: "กรุณาเลือกบริการ",
  contact_err_message_required: "กรุณากรอกข้อความ",
  contact_err_message_limit: "ข้อความต้องไม่เกิน 500 ตัวอักษร",
  contact_thanks_title: "ส่งข้อความแล้ว",
  contact_thanks_desc: "ขอบคุณที่ติดต่อเรา\nหลังจากตรวจสอบข้อความของคุณ เราจะตอบกลับภายใน <strong>2-3 วันทำการ</strong>\nกรุณารอสักครู่",
  contact_thanks_check1: "ตรวจสอบอีเมลยืนยัน",
  contact_thanks_check2: "ตรวจสอบโฟลเดอร์สแปมด้วย",
  contact_thanks_check3: "รอการตอบกลับภายใน 2-3 วันทำการ",
  contact_thanks_another: "ส่งข้อความอีกครั้ง",

  // Footer
  footer_subtitle: "การอ่านชื่อ · โอกินาวา",
  footer_title: "สำนักงานลุงเทนเทน",
  footer_desc: "จากโอกินาวาสู่ทั่วประเทศ อาจารย์ผู้อ่านชื่อที่มีประสบการณ์กว่า 50 ปีอ่านโชคชะตาที่ซ่อนอยู่ในชื่อของคุณอย่างระมัดระวัง",
  footer_contact_title: "ข้อมูลติดต่อ",
  footer_address_label: "ที่อยู่",
  footer_address_value: "โทชิกิ ญี่ปุ่น\n(ออนไลน์ · บริการทั่วประเทศ)",
  footer_email_label: "อีเมล",
  footer_hours_label: "เวลาทำการ",
  footer_hours_value: "จันทร์–ศุกร์ 9:00–18:00\n(ปิดเสาร์/อาทิตย์/วันหยุด)",
  footer_nav_title: "การนำทาง",
  footer_copyright: "© 2025 สำนักงานลุงเทนเทน สงวนลิขสิทธิ์",
  footer_privacy: "นโยบายความเป็นส่วนตัว",
  footer_law: "กฎหมายการค้าเฉพาะ",
  footer_sitemap: "แผนผังเว็บไซต์",
};

export default th;
